// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xEwF","toggleWrap":"styles_toggleWrap__36370","content":"styles_content__17Swd","selectAreaCode":"styles_selectAreaCode__1tstL"};